import React, { useState, createContext, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, Outlet } from 'react-router-dom';
import './index.css';

import CoordinatorLogin from './components/CoordinatorLogin';
import CampDetails from './components/CampDetails';
import ServiceSelection from './components/ServiceSelection';
import TestCaseInput from './components/TestCaseInput';
import CostCalculation from './components/CostCalculation';
import CostSummaryScreen from './components/CostSummaryScreen';
import SimpleCostCalculation from './components/SimpleCostCalculation';
import CustomerDashboard from './components/CustomerDashboard';
import ProtectedRoute, { COUPON_ALLOWED_GROUPS } from './components/ProtectedRoute';
import NewDashboard from './components/NewDashboard';
import ErrorBoundary from './components/ErrorBoundary';
import Dashboard from './components/coordinator/Dashboard';
import ViewServiceSelection from './components/ViewServiceSelection';
import TechnicalDashboard from './components/TechnicialDashboard.js'; // ✅ Explicit .js
import TechnicianMfiDashboard from './components/TechnicianMfiDashboard.jsx';
import MfiServices from './components/MfiServices.jsx';
// import TeleServices from './components/TeleServices.jsx';
import PatientTechnicianDashboard from './components/PatientTechnicianDashboard';
import AddPatient from './components/addpatient.jsx'; // ✅ Explicit .js
import DownloadReports from './components//DownloadReports';
import MedibuddyPatients from './components/MedibuddyPatients';
import PackagePatients from './components/coordinator/PackagePatients';
import PatientMessage from './components/coordinator/PatientMessage';
import TechnicianExpenseDashboard from './components/technicianexpensedashboard.jsx';

// Service Form Components
import AudiometryForm from './components/AudiometryForm'; // ✅ Explicit .js
import ECGForm from './components/ECGForm';
import XrayForm from './components/XrayForm';
import PFTForm from './components/PFTForm';
import OptometryForm from './components/OptometryForm';
import DoctorConsultationForm from './components/DoctorConsultationForm';
import PathologyForm from './components/PathologyForm';
import DentalConsultationForm from './components/DentalConsultationForm';
import VitalsForm from './components/VitalsForm';
import Form7 from './components/Form7';
import BMDForm from './components/BMDForm';
import TetanusVaccineForm from './components/TetanusVaccineForm';
import TyphoidVaccineForm from './components/TyphoidVaccineForm';
import CoordinatorForm from './components/CoordinatorForm';
import CBCForm from './components/CBCForm';
import CompleteHemogramForm from './components/CompleteHemogramForm';
import HemoglobinForm from './components/HemoglobinForm';
import UrineRoutineForm from './components/UrineRoutineForm';
import StoolExaminationForm from './components/StoolExaminationForm';
import LipidProfileForm from './components/LipidProfileForm';
import KidneyProfileForm from './components/KidneyProfileForm';
import LFTForm from './components/LFTForm';
import KFTForm from './components/KFTForm';
import RandomBloodGlucoseForm from './components/RandomBloodGlucoseForm';
import BloodGroupingForm from './components/BloodGroupingForm';
import OnsiteDashboard from './components/OnsiteDashboard';
import StatusTracking from './components/StatusTracking';
import CampStatusPage from './components/CampStatusPage';
import AdminDashboard from './components/Admin/AdminDashboard';
import Medivadi from './components/Medivadi'; // ✅ Explicit .js
import MedibuddyForm from './components/MedibuddyForm';
import NorthstarDashboard from './northstar/northstarDashboard';
import NorthstarPatientDashboard from './northstar/northstarPatientDashboard';
import NorthstarForm from './northstar/northstarFrom.jsx';
import Tata1MGOptometryForm from './components/tata1mg.jsx';
import PatientStatus from './components/PatientStatus.js';
import HealthMonitorApp from './components/HealthMonitorApp.jsx';
// import CampUpload from './components/reportupload/Fileupload.jsx';
import BillingLayout from './components/BillingDashboard/billdashboard.jsx';
import DashboardPage from './components/BillingDashboard/Dashboard.jsx';
import CampsPage from './components/BillingDashboard/Camps.jsx';
import CaseEntryPage from './components/BillingDashboard/CaseEntry.jsx';
import BillingPage from './components/BillingDashboard/Billing.jsx';
import AuditLogPage from './components/BillingDashboard/AuditLog.jsx';
import { syncVitals } from "./utils/syncVitals";
import { syncAudiometry } from "./utils/audiometryOffline";
import { syncOptometryData } from './utils/optometryOffline.js';
import { syncDoctorConsultations } from './utils/doctorConsultation.js';
import { syncServiceMarks } from './utils/indexedDb.js';
// import { syncPatients } from './utils/patientOffline.js';
import { isBackendReachable } from './utils/network.js';
import ActualCasePage from './components/BillingDashboard/actualcase.jsx';
import ResourceManagementDashboard from '../src/components/Resource Management/resourcemanagementdashboard.jsx';
import AdvancePayment from './components/Resource Management/Advancepayment.jsx';
import CampFinancialDashboard from './components/Resource Management/financialsummary.jsx';
import ExpenseManager from './components/Resource Management/Expensemanagemet.jsx';
import InventoryDashboard from './components/coordinator/inventory/InventoryDashboard.jsx';
import ActualCasesRoot from './components/MedibuddyDashboard/medibuddydashboard.jsx';
import DieticianConsultationForm from './components/Dieticianform.jsx'; 
import TCSBillingPage from './components/BillingDashboard/TcsBilling.jsx';
import MfiFinanceActivationPage from './components/BillingDashboard/MfiFinanceActivation.jsx';
import MfiClientsPage from './components/coordinator/mfi/MfiClientsPage.jsx';
import MfiFamiliesPage from './components/coordinator/mfi/MfiFamiliesPage.jsx';
import FamilyCouponsPage from './components/coordinator/mfi/FamilyCouponsPage.jsx';
import MfiReportPage from './components/coordinator/mfi/MfiReportPage.jsx';
import OperationsDashboard from './components/Dashboard/Operations_dashboard/operationDashboard.jsx';
import OperationsCampDetails from './components/Dashboard/Operations_dashboard/operationCamp.jsx';
import AdminDashboard2 from './components/Dashboard/Admin_dashboard/AdminDashboard.jsx';
import AdminCampDetails from './components/Dashboard/Admin_dashboard/AdminCampDetails.jsx';
import TechnicianTeleServices from './components/tele-consultation/TechnicianTeleServices.jsx';
import DoctorTeleConsultationsPage from './components/doctor-teleconsultation/DoctorTeleConsultationsPage';
import DoctorTeleConsultationPage from './components/doctor-teleconsultation/DoctorTeleConsultationPage';
import VitalsWithPathologyForm from './components/VitalsWithPathologyForm.jsx';
import DoctorConsultationWithDC from './components/DoctorConsultationwithDCForm.jsx';
import ReviewerPage from './components/reviewer.jsx';

export const AppContext = createContext();
function App() {
  const [loginType, setLoginType] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [campDetails, setCampDetails] = useState({});
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [caseData, setCaseData] = useState({});
  const [costDetails, setCostDetails] = useState({});

  

  const navigate = useNavigate();
  const isAuthenticated = !!loginType;

  useEffect(() => {
    const storedId = localStorage.getItem("clientId");
    const storedType = localStorage.getItem("loginType");

    if (storedId) setCompanyId(parseInt(storedId));
    if (storedType) setLoginType(storedType);
  }, []);

  useEffect(() => {
    const runFullSync = async () => {
      console.log("🔎 Checking backend reachability...");

      const backendOk = await isBackendReachable();
      console.log("🌐 Backend reachable:", backendOk);

      if (!backendOk) {
        console.log("⛔ Backend not reachable. Skipping sync.");
        return;
      }

      console.log("🚀 Starting full sync cycle...");

      try {
        // await syncPatients();
        await syncVitals();
        await syncAudiometry();
        await syncOptometryData();
        await syncDoctorConsultations();
        await syncServiceMarks();
        console.log("🏁 Sync cycle completed.");
      } catch (err) {
        console.error("❌ Sync cycle error:", err);
      }
    };

    // 🔥 1️⃣ Run once on app load
    runFullSync();

    // 🔥 2️⃣ Run when browser detects online
    const handleOnline = () => {
      console.log("🌐 Browser online event fired");
      runFullSync();
    };

    window.addEventListener("online", handleOnline);

    return () => window.removeEventListener("online", handleOnline);
  }, []);

  

const handleLogin = (type, id, groups = []) => {
    console.log("LOGIN TYPE:", type);
    console.log("CLIENT ID:", id);
    console.log("GROUPS:", groups);

    const normalizedType = Array.isArray(type)
        ? type[0]
        : type;

    setLoginType(normalizedType);
    setCompanyId(id);

    localStorage.setItem("loginType", normalizedType);
    localStorage.setItem("clientId", id);
    localStorage.setItem("groups", JSON.stringify(groups));

    // =========================
    // DOCTOR
    // =========================
    if (groups.includes("Doctor")) {
        console.log("Doctor detected. Redirecting...");

        navigate("/doctor/tele-consultations");
        return;
    }

    // =========================
    // OTHER ROLES
    // =========================

    if (normalizedType === "Coordinator") {
        navigate("/dashboard");

    } else if (normalizedType === "OnsiteCoordinator") {
        navigate("/onsite-dashboard");

    } else if (normalizedType === "CoordinatorNorthStar") {
        navigate("/northstar-dashboard");

    } else if (normalizedType === "Technician") {

        const isMfi =
            localStorage.getItem("is_mfi") === "true";

        if (isMfi) {
            navigate("/technician/mfi-dashboard");
        } else {
            navigate("/technical-dashboard");
        }

    } else if (normalizedType === "Accounts") {
        navigate("/billing/dashboard");

    } else if (normalizedType === "Supervisor") {
        navigate("/billing/dashboard");

    } else if (normalizedType === "Actual") {
        navigate("/actual_case");

    } else if (normalizedType === "ResourceManager") {
        navigate("/resource-allocation");

    } else if (normalizedType === "AdvancePaymentManager") {
        navigate("/advance-payment");

    } else if (normalizedType === "CampFinancial") {
        navigate("/financial-dashboard");

    } else if (normalizedType === "ExpenseManager") {
        navigate("/expense-manager");

    } else if (normalizedType === "MedibuddyManager") {
        navigate("/medibuddy-dashboard");

    } else if (normalizedType === "OperationsManager") {
        navigate("/dashboard/operations");

    } else if (normalizedType === "FinancialAdmin") {
        navigate("/dashboard/admin");
    }
};
  const handleCampDetailsNext = (details) => {
    setCampDetails(details);
    if (details.clientId) {
      setCompanyId(details.clientId);
      localStorage.setItem("clientId", details.clientId);
    }
    navigate('/service-selection');
  };

  const handleServiceSelectionNext = (packagesWithServices, flatServices = []) => {
    setSelectedPackages(packagesWithServices);
    setSelectedServices(flatServices);
    navigate('/test-case-input');
  };

  const handleTestCaseInputNext = (data) => {
    setCaseData(data);
    if (loginType === 'Coordinator') navigate('/cost-calculation');
    else navigate('/simple-cost-calculation');
  };

  const handleCostCalculationNext = (details) => {
    setCostDetails(details);
    navigate('/cost-summary');
  };

  const handleFinalSubmit = () => {
    setLoginType(null);
    setCompanyId(null);
    setCampDetails({});
    setSelectedServices([]);
    setSelectedPackages([]);
    setCaseData({});
    setCostDetails({});
    localStorage.removeItem('authToken');
    localStorage.removeItem('clientId');
    localStorage.removeItem('loginType');
    navigate('/login');
  };

  const handleLogout = () => handleFinalSubmit();
  const username = localStorage.getItem('companyName');

  const handleBackFromServiceSelection = () => navigate('/camp-details');
  const handleBackFromTestCaseInput = () => navigate('/service-selection');
  const handleBackFromCostCalculation = () => navigate('/test-case-input');

  const contextValue = {
    loginType,
    companyId,
    campDetails,
    selectedServices,
    selectedPackages,
    caseData,
    costDetails,
    handleLogin,
    handleCampDetailsNext,
    handleServiceSelectionNext,
    handleTestCaseInputNext,
    handleCostCalculationNext,
    handleFinalSubmit,
    handleLogout,
  };

  return (
    <ErrorBoundary>
      <AppContext.Provider value={contextValue}>
        <div className="container mx-auto p-4">
          {window.location.pathname === '/cost-summary' && (
            <button
              onClick={handleLogout}
              className="bg-red-500 text-white py-2 px-4 rounded shadow hover:bg-red-700"
            >
              Logout
            </button>
          )}

          <Routes>
            {/* Authentication Routes */}
            <Route path="/login" element={<CoordinatorLogin onLogin={handleLogin} />} />
            
            {/* Main Application Routes */}
            <Route path="/camp-details" element={<CampDetails onNext={handleCampDetailsNext} />} />
            <Route 
              path="/service-selection" 
              element={
                <ServiceSelection 
                  onNext={handleServiceSelectionNext}
                  onBack={handleBackFromServiceSelection}
                />
              } 
            />
            <Route 
              path="/test-case-input" 
              element={
                <TestCaseInput 
                  onNext={handleTestCaseInputNext}
                  onBack={handleBackFromTestCaseInput}
                />
              } 
            />
            <Route 
              path="/cost-calculation" 
              element={
                <CostCalculation 
                  companyId={companyId}
                  selectedPackages={selectedPackages}
                  caseData={caseData}
                  onNext={handleCostCalculationNext}
                  onBack={handleBackFromCostCalculation}
                  onSubmit={handleCostCalculationNext}
                />
              } 
            />
            <Route 
              path="/onsite-dashboard" 
              element={<ProtectedRoute element={<OnsiteDashboard />} isAuthenticated={isAuthenticated} />} 
            />
            <Route 
              path="/cost-summary" 
              element={
                <CostSummaryScreen 
                  clientId={companyId} // 👈 pass the prop correctly
                  caseData={caseData}
                  costDetails={costDetails}
                  campDetails={campDetails}
                />
              } 
            />
            <Route path="/simple-cost-calculation" element={<SimpleCostCalculation username={username} />} />
            
            {/* Dashboard Routes */}
            <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} isAuthenticated={isAuthenticated} />} />
            
            <Route path="/customer-dashboard" element={<ProtectedRoute element={<CustomerDashboard />} isAuthenticated={isAuthenticated} />} />
            <Route path="/newdashboard" element={<NewDashboard />} />
            <Route path="/view-serviceselection/:campId" element={<ViewServiceSelection />} />
            <Route path="/technical-dashboard" element={<TechnicalDashboard />} />
            <Route path="/technician/mfi-dashboard" element={<TechnicianMfiDashboard />} />
            <Route path="/technician/mfi-services/:familyId/:memberId" element={<MfiServices />} />
            <Route path="/technician/mfi-services" element={<MfiServices />} />
            {/* <Route path="/technician/tele-services/:familyId/:memberId" element={<TeleServices />} /> */}
            {/* <Route path="/technician/tele-services" element={<TeleServices />} /> */}
            <Route path="/patient-dashboard" element={<PatientTechnicianDashboard />} />
            <Route path="/add-patient" element={<AddPatient />} /> {/* 👈 add this */}
            {/* Message page for coordinator to upload photo and send message */}
            <Route path="/p-m/:patientId" element={<PatientMessage />} />
            <Route path="/patient-message/:patientId" element={<PatientMessage />} />
            {/* Service Form Routes */}
            <Route path="/audiometry" element={<AudiometryForm />} />
            <Route path="/tata1mg-optometry" element={<Tata1MGOptometryForm />} />
            <Route path="/ecg" element={<ECGForm />} />
            <Route path="/xray" element={<XrayForm />} />
            <Route path="/pft" element={<PFTForm />} />
            <Route path="/optometry" element={<OptometryForm />} />
            <Route path="/doctor-consultation" element={<DoctorConsultationForm />} />
            <Route path="/dietician-consultation" element={<DieticianConsultationForm />} />
            <Route path="/pathology" element={<PathologyForm />} />
            <Route path="/dental-consultation" element={<DentalConsultationForm />} />
            <Route path="/vitals" element={<VitalsForm />} />
            <Route path="/form7" element={<Form7 />} />
            <Route path="/bmd" element={<BMDForm />} />
            <Route path="/tetanus-vaccine" element={<TetanusVaccineForm />} />
            <Route path="/typhoid-vaccine" element={<TyphoidVaccineForm />} />
            <Route path="/coordinator" element={<CoordinatorForm />} />
            <Route path="/cbc" element={<CBCForm />} />
            <Route path="/complete-hemogram" element={<CompleteHemogramForm />} />
            <Route path="/hemoglobin" element={<HemoglobinForm />} />
            <Route path="/urine-routine" element={<UrineRoutineForm />} />
            <Route path="/stool-examination" element={<StoolExaminationForm />} />
            <Route path="/lipid-profile" element={<LipidProfileForm />} />
            <Route path="/kidney-profile" element={<KidneyProfileForm />} />
            <Route path="/lft" element={<LFTForm />} />
            <Route path="/kft" element={<KFTForm />} />
            <Route path="/random-blood-glucose" element={<RandomBloodGlucoseForm />} />
            <Route path="/blood-grouping" element={<BloodGroupingForm />} />
            <Route path="/status-tracking" element={<StatusTracking />} />
            {/* Default Route */}
            <Route path="*" element={<Navigate to="/login" />} />
            <Route path="/campStatus/:campId" element={<CampStatusPage/>} />
            <Route path="/download-reports/:campId" element={<DownloadReports />} />
            <Route path="/medibuddy-package/:campId" element={<MedibuddyPatients />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/medivadi" element={<Medivadi />} />
            <Route path="/medibuddy-form/:patientId" element={<MedibuddyForm />} />
            <Route path="/northstar-dashboard" element={<NorthstarDashboard />} />
            <Route path="/northstar-patient-dashboard" element={<NorthstarPatientDashboard />} />
            <Route path="/northstar-form" element={<NorthstarForm/>} />
            <Route path="/patient-status" element={<PatientStatus />} />
            <Route path="/package-patients/:campId/:packageId" element={<PackagePatients />} />
            <Route path="/health-monitor" element={<HealthMonitorApp/>}/>
            <Route path="/inventory-dashboard" element={<InventoryDashboard />} />
            <Route path="/coordinator/mfi" element={<ProtectedRoute element={<MfiClientsPage />} isAuthenticated={isAuthenticated} />} />
            <Route path="/coordinator/mfi/report-mfi/:clientId/:packageId" element={<ProtectedRoute element={<MfiReportPage />} isAuthenticated={isAuthenticated} />} />
            <Route path="/coordinator/mfi/report-mfi" element={<ProtectedRoute element={<MfiReportPage />} isAuthenticated={isAuthenticated} />} />
            <Route path="/coordinator/mfi/families/:clientId/:packageId" element={<ProtectedRoute element={<MfiFamiliesPage />} isAuthenticated={isAuthenticated} />} />
            <Route path="/coordinator/mfi/families/:clientId/:packageId/coupons/:familyId" element={<ProtectedRoute element={<FamilyCouponsPage />} isAuthenticated={isAuthenticated} allowedGroups={COUPON_ALLOWED_GROUPS} />} />
            <Route path="/coordinator/mfi/families" element={<ProtectedRoute element={<MfiFamiliesPage />} isAuthenticated={isAuthenticated} />} />
            {/* # Route for Camp Upload */}
            {/* <Route path="/camp-upload" element={<CampUpload />} /> */}
            {/* Route for the Resource Allocation */}
            <Route path="/resource-allocation" element={<ResourceManagementDashboard />} />
            <Route path="/technician-expenses" element={<TechnicianExpenseDashboard />} />
            <Route path="/advance-payment" element={<AdvancePayment />} />
            {/* Route for path finance dashboard */}
            <Route path="/financial-dashboard" element={<CampFinancialDashboard />} />
            {/* Route for expense Manager */}
            <Route path="/expense-manager" element={<ExpenseManager />} />
            {/* Route For Medibuddy dashboard  */}
            <Route path="/medibuddy-dashboard" element={<ActualCasesRoot />} />
            <Route path="/doctor-consultation-with-dc" element={<DoctorConsultationWithDC />} />
            <Route path="/vitals-with-pathology" element={<VitalsWithPathologyForm />} />
            <Route
              path="/reviewer"
              element={
                <ProtectedRoute
                  element={<ReviewerPage />}
                  isAuthenticated={isAuthenticated}
                />
              }
            />

            {/* Route For Generate Bills for all patients in a camp */}
            <Route path="/billing" element={<BillingLayout />}>
              <Route index element={<Navigate to="dashboard" />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="camps" element={<CampsPage />} />
              <Route path="case-entry" element={<CaseEntryPage />} />
              <Route path="billing" element={<BillingPage />} />
              <Route path="audit-log" element={<AuditLogPage />} />
              <Route path="tcs-billing" element={<TCSBillingPage />} />
              <Route path="mfi-finance" element={<MfiFinanceActivationPage />} />
            </Route>
            <Route path="/actual_case" element={<ActualCasePage />} />
            {/* Add these two routes near your existing "/dashboard" route: */}
            <Route
              path="/dashboard/operations"
              element={<ProtectedRoute element={<OperationsDashboard />} isAuthenticated={isAuthenticated} />}
            />
            <Route
              path="/dashboard/operations/camp/:campId"
              element={<ProtectedRoute element={<OperationsCampDetails />} isAuthenticated={isAuthenticated} />}
            />
            {/* Route Path For Admin Dashboard */}
            <Route path="/dashboard/admin" element={<ProtectedRoute element={<AdminDashboard2 />} isAuthenticated={isAuthenticated} />} />
            <Route path="/dashboard/admin/camp/:campId" element={<ProtectedRoute element={<AdminCampDetails />} isAuthenticated={isAuthenticated} />} />
            <Route path="/technician/tele-services/:familyId/:memberId" element={<TechnicianTeleServices />}/>
            <Route path="/doctor/tele-consultations" element={<DoctorTeleConsultationsPage />} />
            <Route path="/doctor/tele-consultations/:consultationId" element={<DoctorTeleConsultationPage />} />
          </Routes>


          <Outlet />
        </div>
      </AppContext.Provider>
    </ErrorBoundary>
  );
  
}

export default App;